module.exports = {
  AUTH_TOKEN_KEY: 'auth_tkn',
  GOOGLE_MAP_KEY: 'AIzaSyAa8zAXcJKuOP3-n1rpKClf5uqDAMZGVO4',
  GOOGLE_MAP_ID: 'd4893f48cdbd6ef8',
  DATE_FORMAT_API: 'yyyy-MM-DD'
};
